import { Model } from "@/models";
import ClientCompany from "./Company";
import ClientAgent from "./Agent";

export default class ClientAgentCompanyAgentAssociation extends Model {
  static type = "clientsAgentCompanyAgentAssociations";

  agentCompany!: ClientCompany;
  agent!: ClientAgent;
  agentType!: string;
}
